class ConnectedUserReportController {
    constructor($window, $location, moment, toastr, ngProgressFactory, TraceHubExService, SettingsService, ReportUtils, ReportServiceApi) {
        // Use $onInit to initialise component
        this.$onInit = () => {
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                showReport: true,
                connectionId: 0
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.connectedUserReport = {
                Id: 0,
                Name: '',
                Description: 'Connected Users Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.data = {
                connectedUsers: []
            };
            this.rowCount = 0;
            this.state.showReport = false;
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                this.appSettings = response.data;
                if (this.appSettings.UseSingleSignOn) {
                    this.columnDefs = [
                        {
                            headerName: 'Id',
                            field: 'SSOUsersDetails.IdPId.Value',
                            minWidth: 70,
                            hide: true
                        },
                        {
                            headerName: 'User',
                            field: 'SSOUsersDetails.IdPEmail.Value',
                            minWidth: 90,
                            suppressSizeToFit: false
                        },
                        {
                            headerName: 'WBT User',
                            field: 'UserName',
                            minWidth: 90,
                            suppressSizeToFit: false
                        },
                        {
                            headerName: 'Role',
                            field: 'Role',
                            minWidth: 90,
                            suppressSizeToFit: false
                        }
                    ];
                }
                else {
                    // NOTE: SignalR Methods
                    this.columnDefs = [
                        {
                            headerName: 'Id',
                            field: 'Id',
                            minWidth: 70,
                            hide: true
                        },
                        {
                            headerName: 'User',
                            field: 'Description',
                            minWidth: 90,
                            suppressSizeToFit: false
                        },
                        {
                            headerName: 'Role',
                            field: 'CoreRole',
                            minWidth: 90,
                            suppressSizeToFit: false
                        }
                    ];
                }
                this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
                this.gridOptions.onGridReady = () => {
                    this.gridReady = true;
                    this.onNewUser();
                };
                this.TraceHubExService.connectWithSpecificTransport('ConnectedUserReportController', this.appSettings.SignalRTransport);
                this.TraceHubExService.on('ConnectedUserReportController', 'onInit', (connId) => {
                    this.state.connectionId = connId;
                });
                this.TraceHubExService.on('ConnectedUserReportController', 'onNewUser', (connectedUsers) => {
                    this.state.showReport = true;
                    if (this.data.connectedUsers.length !== connectedUsers.length) {
                        this.traceProgress.start();
                        this.data.connectedUsers = connectedUsers;
                        this.onNewUser();
                    }
                });
            });
            this.ReportServiceApi.getReportByName('ConnectedUserReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.connectedUserReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.onNewUser = () => {
            if (this.gridReady) {
                this.gridOptions.api.setRowData(this.data.connectedUsers);
            }
            this.traceProgress.complete();
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('ConnectedUserReportController');
        };
        // TODO: Show updated results in real time
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
            // this.gridOptions.api.sizeColumnsToFit();
        };
        this.addDateToTitle = (title) => {
            const ydm = this.moment().format('YYYYDDMM');
            const hhmm = this.moment().format('hhmm');
            const reportName = [ydm, ' ', hhmm, ' ', title].join('');
            return reportName;
        };
        this.exportCsv = () => {
            const title = this.connectedUserReport.Description + '.csv';
            const reportName = this.addDateToTitle(title);
            const params = {
                allColumns: false,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.window = $window;
        this.location = $location;
        this.moment = moment;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.TraceHubExService = TraceHubExService;
        this.SettingsService = SettingsService;
        this.ReportUtils = ReportUtils;
        this.ReportServiceApi = ReportServiceApi;
    }
}
angular.module('app').component('connectedUserReport', {
    templateUrl: 'Scripts/App/partials/Reports/connected-user-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ConnectedUserReportController
});
